<app-form-navigation></app-form-navigation>
<div class="container{{uS.environment.wideScreen?'-fluid':''}} view-body {{uS.environment.bodyClass}}">
  <router-outlet></router-outlet>
  <watermark />
</div>
